function postMessageToken(iframe, token) {
    if (iframe === true && window.parent && token) {
        window.parent.postMessage(token, '*');
    }
}

export { postMessageToken };
